import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {},
    components: {
        shelfRulePage: {
            component: 'Viewport',
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/product',
                    breadcrumbName: '商品管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/shelfRule',
                            component: 'shelfRulePage',
                            breadcrumbName: '上下架规则',
                            childRoutes: [
                                {
                                    path: '/',
                                    component: 'shelfRuleListView',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};
